import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { OptionType } from "@shared/ui/Select";

import { apiRequest } from "@shared/services/api/apiRequest";

type Props = {
  shouldLoad?: boolean;
};

export function useGetOrganizations({ shouldLoad = false }: Props) {
  const [options, setOptions] = useState<OptionType[]>([]);

  const loadOrgs = async () => {
    const res = await apiRequest(`/api/lookup-organizations/`, "GET");

    return res.map((org: any) => ({
      label: org.organization_name,
      value: org.organization_id.toString(),
      data: org,
    }));
  };

  const loadOrganizationsQuery = useQuery({
    queryKey: ["organizations"],
    queryFn: loadOrgs,
    enabled: shouldLoad,
  });

  useEffect(() => {
    if (loadOrganizationsQuery.data) {
      setOptions((prev) => {
        const createdOptions = prev.filter((opt) => opt.data?.created);

        const combined = [...loadOrganizationsQuery.data, ...createdOptions];

        return Array.from(
          new Map(combined.map((opt) => [opt.value, opt])).values()
        );
      });
    }
  }, [loadOrganizationsQuery.data]);

  return {
    options,
    setOptions,
    isLoading: loadOrganizationsQuery.isLoading,
  };
}

export default useGetOrganizations;
